import { createSlice } from '@reduxjs/toolkit';
const userStore = createSlice({
    name: 'user',
    initialState: {
        userInfo:{},
        authcode:''
    },
    reducers: {
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
    }
})
const { setUserInfo } = userStore.actions
const getUserInfo = (params) => {
    return (dispatch) => {
        dispatch(setUserInfo(params));
    }
}
export { getUserInfo }
const reducers = userStore.reducer
export default reducers;